const formatTelefone = (telefone) => {
  if (telefone) {
    telefone = telefone.slice(0, 10);
    return telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return telefone;
};

export default formatTelefone;
